package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.russhwolf.settings.Settings
import io.github.aakira.napier.Napier

class IncreaseNumberOfSearchesUseCase(
    private val settings: Settings,
) {

    operator fun invoke(): Int {
        val current = settings.getInt(
            key = Constants.PREF_USER_NUMBER_OF_SEARCHES,
            defaultValue = 0,
        )

        val updated = current + 1

        settings.putInt(
            key = Constants.PREF_USER_NUMBER_OF_SEARCHES,
            value = updated,
        )

        Napier.d(
            message = "User search count updated from $current to $updated (key=${Constants.PREF_USER_NUMBER_OF_SEARCHES})",
            tag = "IncreaseNumberOfSearches",
        )

        return updated
    }
}
